import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.html',
  styleUrl: './unauthorized.scss',
  standalone: false // NOSONAR

})
export class Unauthorized {
  constructor(
    ) {}
  
    ngOnInit(): void { // NOSONAR 

      console.info('')
    }
}
